import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';

/**
 * Generated class for the MappingDialogComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: 'mapping-dialog',
  templateUrl: 'mapping-dialog.html'
})
export class MappingDialogComponent {

    mappingtype: string = 'value';
    imagemappingtype: string = 'value';
    
  constructor(public dialogRef:MatDialogRef <MappingDialogComponent>,@Inject(MAT_DIALOG_DATA) public data: any) {
    console.log('Hello MappingDialogComponent Component');
  }
  
  addMapping()
  {
      this.dialogRef.close();
  }
  
}



// WEBPACK FOOTER //
// ./src/components/mapping-dialog/mapping-dialog.ts